// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Assistant/Assistant-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Assistant/Assistant-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Assistant/Assistant-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Assistant/Assistant-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/Assistant/Assistant-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/Assistant/Assistant-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/Assistant/Assistant-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/Assistant/Assistant-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/Assistant/Assistant-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/Assistant/Assistant-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/Assistant/Assistant-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/Assistant/Assistant-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- FONTS --- */

@font-face {
    font-family: 'Assistant';
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
}

@font-face {
    font-family: 'Assistant Light';
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2');
}

@font-face {
    font-family: 'Assistant Semi Bold';
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2');
}

@font-face {
    font-family: 'Assistant Bold';
    font-style: normal;
    font-weight: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff2');
}

/* ---------- */

#chatbot-external {
    font-family: "Assistant", sans-serif;
    font-size: 14px;
}
#chatbot-external h1,
#chatbot-external h2 {
    font-family: "Assistant Bold", sans-serif;
}
#chatbot-external h1 {
    margin-bottom: 0;
    font-size: 30px;
    color: #152D62;
}
#chatbot-external h2 {
    margin-top: 0;
    margin-bottom: 25px;
    font-size: 18px;
    color: #152D62;
}
#chatbot-external p {
    margin-top: 0;
    margin-bottom: 40px;
    font-size: 14px;
    color: #74889D;
}

#chatbot-external #versionNumber {
    padding: 5px 10px;
}

#chatbot-external #iframeForm {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 80%;
    text-align: center;
}

#chatbot-external #iframeForm #btnStopPreview {
    position: absolute;
    top: 20px;
    display: none;
    align-items: center;
    padding: 20px 35px;
    border: none;
    background: #33333B 0 0 no-repeat padding-box;
    box-shadow: 0 3px 6px #00000080;
    border-radius: 78px;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}
#chatbot-external #iframeForm #btnStopPreview:hover {
    background: #000000 0 0 no-repeat padding-box;
}
#chatbot-external #iframeForm #btnStopPreview img {
    width: 19px;
    height: 19px;
    padding-left: 12px;
}

#chatbot-external #iframeForm .container-texts {
    width: 75%;
}

#chatbot-external #iframeForm .container-input {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

#chatbot-external #iframeForm input#urlInput {
    width: 80%;
    margin-bottom: 20px;
    padding: 9px 8px;
    border-radius: 6px;
    border: 1px solid #CAD5DB;
}

#chatbot-external #iframeForm input#urlInput::placeholder,
#chatbot-external #iframeForm input#urlInput::-webkit-input-placeholder,
#chatbot-external #iframeForm input#urlInput:-moz-placeholder,
#chatbot-external #iframeForm input#urlInput::-moz-placeholder {
    color: #95a5a6;
}

#chatbot-external #iframeForm button#btnDisplayIframe {
    width: 174px;
    height: 36px;
    color:#FFFFFF;
    border: none;
    border-radius: 6px;
    background: #4545C9 0 0 no-repeat padding-box;
    cursor: pointer;
}

/* --- MEDIA QUERIES --- */

@media screen and (min-width: 375px) {
    #chatbot-external #iframeForm .container-texts {
        width: 90%;
    }
}
@media screen and (min-width: 720px) {
    #chatbot-external h1 {
        font-size: 50px;
    }
    #chatbot-external h2 {
        font-size: 30px;
    }
    #chatbot-external p {
        font-size: 16px;
    }

    #chatbot-external #iframeForm .container-texts {
        width: 75%;
    }

    #chatbot-external #iframeForm .container-input input#urlInput {
        width: 70%;
    }
}

@media screen and (min-width: 1650px) {
    #chatbot-external #iframeForm {
        justify-content: center;
    }

    #chatbot-external #iframeForm .container-texts {
        width: 36%;
    }

    #chatbot-external #iframeForm .container-input input#urlInput {
        width: 35%;
    }
}`, "",{"version":3,"sources":["webpack://./public/chatboxHomepage.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;;2DAE8D;AAClE;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB;;2DAE4D;AAChE;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB;;2DAE+D;AACnE;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB;;4DAE2D;AAC/D;;AAEA,eAAe;;AAEf;IACI,oCAAoC;IACpC,eAAe;AACnB;AACA;;IAEI,yCAAyC;AAC7C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,6CAA6C;IAC7C,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;AACnB;;AAEA,0BAA0B;;AAE1B;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":["/* --- FONTS --- */\r\n\r\n@font-face {\r\n    font-family: 'Assistant';\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    src: url('fonts/Assistant/Assistant-Regular.ttf') format('truetype'),\r\n    url('fonts/Assistant/Assistant-Regular.woff') format('woff'),\r\n    url('fonts/Assistant/Assistant-Regular.woff2') format('woff2');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Assistant Light';\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    src: url('fonts/Assistant/Assistant-Light.ttf') format('truetype'),\r\n    url('fonts/Assistant/Assistant-Light.woff') format('woff'),\r\n    url('fonts/Assistant/Assistant-Light.woff2') format('woff2');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Assistant Semi Bold';\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    src: url('fonts/Assistant/Assistant-SemiBold.ttf') format('truetype'),\r\n    url('fonts/Assistant/Assistant-SemiBold.woff') format('woff'),\r\n    url('fonts/Assistant/Assistant-SemiBold.woff2') format('woff2');\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Assistant Bold';\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    src: url('fonts/Assistant/Assistant-Bold.ttf') format('truetype'),\r\n    url('fonts/Assistant/Assistant-Bold.woff') format('woff'),\r\n    url('fonts/Assistant/Assistant-Bold.woff2') format('woff2');\r\n}\r\n\r\n/* ---------- */\r\n\r\n#chatbot-external {\r\n    font-family: \"Assistant\", sans-serif;\r\n    font-size: 14px;\r\n}\r\n#chatbot-external h1,\r\n#chatbot-external h2 {\r\n    font-family: \"Assistant Bold\", sans-serif;\r\n}\r\n#chatbot-external h1 {\r\n    margin-bottom: 0;\r\n    font-size: 30px;\r\n    color: #152D62;\r\n}\r\n#chatbot-external h2 {\r\n    margin-top: 0;\r\n    margin-bottom: 25px;\r\n    font-size: 18px;\r\n    color: #152D62;\r\n}\r\n#chatbot-external p {\r\n    margin-top: 0;\r\n    margin-bottom: 40px;\r\n    font-size: 14px;\r\n    color: #74889D;\r\n}\r\n\r\n#chatbot-external #versionNumber {\r\n    padding: 5px 10px;\r\n}\r\n\r\n#chatbot-external #iframeForm {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    height: 80%;\r\n    text-align: center;\r\n}\r\n\r\n#chatbot-external #iframeForm #btnStopPreview {\r\n    position: absolute;\r\n    top: 20px;\r\n    display: none;\r\n    align-items: center;\r\n    padding: 20px 35px;\r\n    border: none;\r\n    background: #33333B 0 0 no-repeat padding-box;\r\n    box-shadow: 0 3px 6px #00000080;\r\n    border-radius: 78px;\r\n    color: #FFFFFF;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n#chatbot-external #iframeForm #btnStopPreview:hover {\r\n    background: #000000 0 0 no-repeat padding-box;\r\n}\r\n#chatbot-external #iframeForm #btnStopPreview img {\r\n    width: 19px;\r\n    height: 19px;\r\n    padding-left: 12px;\r\n}\r\n\r\n#chatbot-external #iframeForm .container-texts {\r\n    width: 75%;\r\n}\r\n\r\n#chatbot-external #iframeForm .container-input {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n#chatbot-external #iframeForm input#urlInput {\r\n    width: 80%;\r\n    margin-bottom: 20px;\r\n    padding: 9px 8px;\r\n    border-radius: 6px;\r\n    border: 1px solid #CAD5DB;\r\n}\r\n\r\n#chatbot-external #iframeForm input#urlInput::placeholder,\r\n#chatbot-external #iframeForm input#urlInput::-webkit-input-placeholder,\r\n#chatbot-external #iframeForm input#urlInput:-moz-placeholder,\r\n#chatbot-external #iframeForm input#urlInput::-moz-placeholder {\r\n    color: #95a5a6;\r\n}\r\n\r\n#chatbot-external #iframeForm button#btnDisplayIframe {\r\n    width: 174px;\r\n    height: 36px;\r\n    color:#FFFFFF;\r\n    border: none;\r\n    border-radius: 6px;\r\n    background: #4545C9 0 0 no-repeat padding-box;\r\n    cursor: pointer;\r\n}\r\n\r\n/* --- MEDIA QUERIES --- */\r\n\r\n@media screen and (min-width: 375px) {\r\n    #chatbot-external #iframeForm .container-texts {\r\n        width: 90%;\r\n    }\r\n}\r\n@media screen and (min-width: 720px) {\r\n    #chatbot-external h1 {\r\n        font-size: 50px;\r\n    }\r\n    #chatbot-external h2 {\r\n        font-size: 30px;\r\n    }\r\n    #chatbot-external p {\r\n        font-size: 16px;\r\n    }\r\n\r\n    #chatbot-external #iframeForm .container-texts {\r\n        width: 75%;\r\n    }\r\n\r\n    #chatbot-external #iframeForm .container-input input#urlInput {\r\n        width: 70%;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 1650px) {\r\n    #chatbot-external #iframeForm {\r\n        justify-content: center;\r\n    }\r\n\r\n    #chatbot-external #iframeForm .container-texts {\r\n        width: 36%;\r\n    }\r\n\r\n    #chatbot-external #iframeForm .container-input input#urlInput {\r\n        width: 35%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
